import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";

import {
  upsSlider1Img,
  upsSlider2Img,
  upsSlider3Img,
  upsSlider4Img,
} from "@/utils/images";
import Image from "next/image";

const items = [
  {
    src: upsSlider1Img,
    altText: "",
    caption: "",
    key: 1,
  },
  {
    src: upsSlider2Img,
    key: 2,
  },
  {
    src: upsSlider3Img,
    key: 3,
  },
  {
    src: upsSlider4Img,
    key: 4,
  },
];

function PricingCarousel(args: any) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
        className="text-center"
      >
        <Image src={item.src} alt={item.src} height={400} width={320} />
        <CarouselCaption
          captionText={item.caption ?? ""}
          captionHeader={item.caption ?? ""}
        />
      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      {...args}
    >
      <CarouselIndicators
        items={items}
        activeIndex={activeIndex}
        onClickHandler={goToIndex}
        style={{ bottom: "-50px" }}
      />
      {slides}
      <CarouselControl
        direction="prev"
        directionText="Previous"
        onClickHandler={previous}
      />
      <CarouselControl
        direction="next"
        directionText="Next"
        onClickHandler={next}
      />
    </Carousel>
  );
}

export default PricingCarousel;
